import { GOOGLE_MAPS_SEARCH_LINK } from '../config/constants';

/**
 * Generate a google maps link.
 *
 * @param {string} addressPart1
 * @param {string} addressPart2
 * @param {string} addressPart3
 *
 * @returns {[string, string]} A tuple with the google maps link and the address.
 */
const addressMapsLink = (addressPart1: string, addressPart2: string, addressPart3: string): [string, string] => {
  const parts = [
    addressPart1,
    addressPart2,
    addressPart3,
  ].filter((val) => val && val.length > 0);

  const params = new URLSearchParams();
  params.append('api', '1');
  params.append('query', parts.join(', '));

  return [
    `${String(GOOGLE_MAPS_SEARCH_LINK)}?${params.toString()}`,
    `${parts.join(', ')}`,
  ];
};

export default addressMapsLink;
